type TranslationPart =
    | { type: 'text'; content: string }
    | { type: 'br' }
    | { type: 'link'; label: string; url: string };

const useTranslationLinkParser = () => {
    const parseTranslation = (text: string): TranslationPart[] => {
        const parts: TranslationPart[] = [];
        const regex = /(\n)|\[([^\]]+)\]\(([^)]+)\)/g;
        let lastIndex = 0;
        let match;

        while ((match = regex.exec(text)) !== null) {
            if (match.index > lastIndex) {
                parts.push({ type: 'text', content: text.slice(lastIndex, match.index) });
            }
            if (match[1]) {
                parts.push({ type: 'br' });
            } else {
                parts.push({ type: 'link', label: match[2], url: match[3] });
            }
            lastIndex = match.index + match[0].length;
        }

        if (lastIndex < text.length) {
            parts.push({ type: 'text', content: text.slice(lastIndex) });
        }

        return parts;
    };

    return { parseTranslation };
};

export type { TranslationPart };
export { useTranslationLinkParser };
